import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import Collapse from '@material-ui/core/Collapse';
import { Dvr, PhotoLibrary, MeetingRoom, Home, Close, Menu as MenuIcon, ExpandMore, ExpandLess, Ballot, Assignment} from '@material-ui/icons';
import { ReactComponent as FireHoseIcon } from '../../assets/fire-hose.svg';

import Constants from '../../utils/Constants';
import { useNavigate } from 'react-router-dom';
import useAuthentication from '../../hooks/useAuthentication';
import { hasUserRole } from '../../utils/AuthUtils';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));


const Menu = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  
  const [ isAuthenticated, logout ] = useAuthentication();
  const [ isMenuOpen, setIsMenuOpen] = useState(false);
  const [ mnuOpenInv, setMnuOpenInv] = useState(false);
  const [ mnuOpenHose, setMnuOpenHose] = useState(false);

  let handleClick_menuItem_logout = () => {
    logout();
    
    // Logout and force the page to reload, this will ensure that the
    // Layout and authentication hooks get the correct authentication 
    // state and redirect the user to the login page.
    window.location.reload(); 
  }

  let handleClick_menuItemNavigate = (routePath) => {
    navigate(routePath);

    // Close the sub menus
    setMnuOpenInv(false);
    setMnuOpenHose(false);
    
    setIsMenuOpen(false);
  }

  let handleHamburger = (event) => {
    if (!isMenuOpen) { // Menu is currently closed
      setIsMenuOpen(true);
    } else {
      setIsMenuOpen(false);
    }
  }
  
  const renderMenuItems = () => {
    if (!isAuthenticated) {
      return null;
    }

    // Check users Roles to see which menus are visible.
    let isInventoryActive = hasUserRole(Constants.UserRole.InventoryUser) || hasUserRole(Constants.UserRole.InventoryManager);
    let isHoseActive = hasUserRole(Constants.UserRole.HoseUser) || hasUserRole(Constants.UserRole.HoseManager);

    return (
      <>
        <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={ handleHamburger }>
          <MenuIcon />
        </IconButton>
        <Drawer anchor="left" open={isMenuOpen} onClose={handleHamburger}>
          <div style={{width: '250px'}}>

            <ListItem button key="mnuClose" onClick={handleHamburger} style={{flexDirection: 'row-reverse'}}>
              <ListItemIcon style={{minWidth: '24px', width: '30px'}}><Close /></ListItemIcon>
            </ListItem>
            <ListItem button key="mnuHome" onClick={() => handleClick_menuItemNavigate(Constants.RoutePath.Landing)}>
              <ListItemIcon><Home /></ListItemIcon>
              <ListItemText primary="Home" />
            </ListItem>


            { isInventoryActive ?
              <>
                <ListItem button onClick={() => setMnuOpenInv(!mnuOpenInv)}>
                  <ListItemIcon>
                    <Ballot />
                  </ListItemIcon>
                  <ListItemText primary="Inventory" />
                  {mnuOpenInv ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={mnuOpenInv} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem 
                      button 
                      key="mnuInventoryListing" 
                      onClick={() => handleClick_menuItemNavigate(Constants.RoutePath.Inventory.List)}
                      style={{marginLeft:"1em"}}
                    >
                      <ListItemIcon><Assignment /></ListItemIcon>
                      <ListItemText primary="Inventories" />
                    </ListItem>
                    <ListItem button key="mnuInventoryGallery" onClick={() => handleClick_menuItemNavigate(Constants.RoutePath.Gallery.View)} style={{marginLeft:"1em"}}> 
                      <ListItemIcon><PhotoLibrary /></ListItemIcon>
                      <ListItemText primary="Gallery" />
                    </ListItem>
                    <ListItem button key="mnuInventoryManage" onClick={() => handleClick_menuItemNavigate(Constants.RoutePath.Inventory.Manage)} style={{marginLeft:"1em"}}> 
                      <ListItemIcon><Dvr /></ListItemIcon>
                      <ListItemText primary="Manage" />
                    </ListItem>
                  </List>
                </Collapse>
              </>
            : null } 

            { isHoseActive ? 
              <>
                <ListItem button onClick={() => setMnuOpenHose(!mnuOpenHose)}>
                  <ListItemIcon>
                    <FireHoseIcon width="24px" height="24px" fill="#757575"/>
                  </ListItemIcon>
                  <ListItemText primary="Hoses" />
                  {mnuOpenHose ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={mnuOpenHose} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem button key="mnuHoseListing" onClick={() => handleClick_menuItemNavigate(Constants.RoutePath.HoseManagement.Listing)} style={{marginLeft:"1em"}}>
                      <ListItemIcon><Assignment /></ListItemIcon>
                      <ListItemText primary="Records" />
                    </ListItem>
                  </List>
                </Collapse>
              </>
            : null }

            <Divider />

            <ListItem button key="mnuLogout" onClick={handleClick_menuItem_logout}>
              <ListItemIcon><MeetingRoom /></ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItem>
          </div>
        </Drawer>
      </>
    );
  }

  return (
    <div>
      <AppBar position="static">
        <Toolbar>
          { renderMenuItems() }
          <Typography variant="h6" className={classes.title}>
            ERMA Apps
          </Typography>
          { !isAuthenticated ? <Button color="inherit" href={Constants.RoutePath.Login}>Login</Button> : null }
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default Menu;
